function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(-31 -327)"
}, React.createElement("g", {
  transform: "translate(31 327)",
  fill: "#fff",
  stroke: "#353535",
  strokeWidth: 1
}, React.createElement("circle", {
  cx: 15,
  cy: 15,
  r: 15,
  stroke: "none"
}), React.createElement("circle", {
  cx: 15,
  cy: 15,
  r: 14.5,
  fill: "none"
})), React.createElement("path", {
  d: "M-1680.59-4527.908h16.907",
  transform: "translate(1719 4870)",
  fill: "none",
  stroke: "#353535",
  strokeWidth: 1
}), React.createElement("path", {
  d: "M-1675.267-4535.382l-5.112,7.609,5.112,6.894",
  transform: "translate(1719 4870)",
  fill: "none",
  stroke: "#353535",
  strokeWidth: 1
}));

var SvgIconArrow = function SvgIconArrow(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconArrow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_arrow.30055ac1.svg";
export { ForwardRef as ReactComponent };